import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AppContextProvider from "./utils/Context/AppContext";
import { MsalProvider } from "@azure/msal-react";
import mslInstance from "./utils/MSL/mslInstance";

const initializeApp = async () => {
  try {
    await mslInstance.initialize();

    const response = await mslInstance.handleRedirectPromise();
    if (response) {
      mslInstance.setActiveAccount(response.account);
    } else {
      const accounts = mslInstance.getAllAccounts();
      if (accounts.length > 0) {
        mslInstance.setActiveAccount(accounts[0]);
      }
    }

    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <BrowserRouter>
        {" "}
        {/* ✅ Outer Router wraps everything */}
        <MsalProvider instance={mslInstance}>
          <AppContextProvider>
            <App />
          </AppContextProvider>
        </MsalProvider>
      </BrowserRouter>
    );
  } catch (error) {
    console.error("MSAL initialization or redirect handling failed:", error);
  }
};

initializeApp();
reportWebVitals();
